module.exports = __webpack_public_path__ + "static/media/supportMessagesSent_25_50.a1bff06a.png";